import { useParams } from 'react-router-dom';
import PatientDetails from '../../../components/PatientDetails/PatientDetails';
import TreatmentsTable from '../../../components/TreatmentsTable/TreatmentsTable';
import { $t } from "../../../helpers/translator";

function ChainPatient() {
    const params = useParams();
    const userType = 3;

   return (
        <>
            <PatientDetails userType={userType} id={params.id} />
            <TreatmentsTable userType={userType} patientId={ params.id }
                header={ $t('global.treatments.patientTreatments') } />
        </>
   )
}


export default ChainPatient;
